import { setGamePayload } from '@/store/actions';
import type { GamePayload } from '@/store/slices/game/types';

export const emptyGameGlsPayload = (): Pick<
  GamePayload,
  'glsInitializeUrl' | 'handshakeLaunchEpoch'
> => ({
  glsInitializeUrl: null,
  handshakeLaunchEpoch: null,
});

/** Clears GLS init URL and delivery handshake epoch (delivery-only; `gameContext` unchanged). */
export const clearGameGlsPayload = (): void => {
  setGamePayload(emptyGameGlsPayload());
};
